import { uuid } from "uuidv4";
import { fileStore } from "./fileStore";
import { templateActions } from "@pages/Applications/C&C/C&CSetup/templateStore";

export function remapKeys(
    obj: Record<string, any>,
    keyMappings: Record<string, string>
) {
    const temp: Record<string, any> = {};
    for (const [oldKey, newKey] of Object.entries(keyMappings)) {
        temp[newKey] = obj[oldKey];
    }
    for (const oldKey of Object.keys(keyMappings)) {
        delete obj[oldKey];
    }
    Object.assign(obj, temp);
    return obj;
}
export const handleDragEnd = (
    result: any,
    path: any,
    data: any,
    section: string,
    deviceType: string
) => {
    if (section !== "Section1") {
        if (!result.destination) return;
        if (result.source.index === result.destination.index) return;
        const items = [...data];
        const [movedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, movedItem);
        const updatedItems = items.map((item, index) => ({
            ...item,
            Rank: index + 1,
            id: item.id || uuid(),
        }));
        const keyMappings: Record<string, string> = {};
        const pathPrefix = path.join(".");
        updatedItems.forEach((item) => {
            if (item.Pub?.Url?.startsWith("blob:")) {
                const oldKey = Object.keys(fileStore).find((key) => {
                    return (
                        key.startsWith(pathPrefix) &&
                        fileStore[key] &&
                        item.Pub.Name === fileStore[key]?.name
                    );
                });
                const newKey = `${pathPrefix}.${item.Rank}`;
                if (oldKey) {
                    keyMappings[oldKey] = newKey;
                } else {
                    console.warn(
                        "Blob file not found in store for item:",
                        item
                    );
                }
            }
        });
        remapKeys(fileStore, keyMappings);
        const itemsWithoutId = updatedItems.map(({ id, ...rest }) => rest);
        try {
            templateActions.updateTemplate(path, itemsWithoutId);
        } catch (error) {
            console.error("Update failed:", error);
        }
    } else {
        if (!result.destination) return;
        if (result.destination.index === result.source.index) return;
        const sectionData = templateActions.getNestedObject(path);
        const imageKeys = Object.keys(sectionData)
            .filter((key) => key.startsWith("Image"))
            .sort(
                (a, b) =>
                    parseInt(a.replace("Image", "")) -
                    parseInt(b.replace("Image", ""))
            );
        const [removedKey] = imageKeys.splice(result.source.index, 1);
        imageKeys.splice(result.destination.index, 0, removedKey);
        const keyMappings: Record<string, string> = {};
        const pathPrefix = path.join(".");
        imageKeys.forEach((oldKey, newIndex) => {
            const newKey = `Image${newIndex + 1}`;
            const mediaData = sectionData[oldKey]?.[deviceType];
            if (mediaData?.Url?.startsWith("blob:")) {
                const fileStoreKey = Object.keys(fileStore).find(
                    (key) =>
                        key.startsWith(
                            `${pathPrefix}.${oldKey}.${deviceType}`
                        ) && fileStore[key]?.name === mediaData.Name
                );
                if (fileStoreKey) {
                    const newFileStoreKey = `${pathPrefix}.${newKey}.${deviceType}`;
                    keyMappings[fileStoreKey] = newFileStoreKey;
                }
            }
        });
        if (Object.keys(keyMappings).length > 0) {
            remapKeys(fileStore, keyMappings);
        }
        const newData: Record<string, any> = {};
        imageKeys.forEach((oldKey, newIndex) => {
            const newKey = `Image${newIndex + 1}`;
            newData[newKey] = sectionData[oldKey];
        });
        Object.keys(sectionData)
            .filter((key) => !key.startsWith("Image"))
            .forEach((key) => {
                newData[key] = sectionData[key];
            });
        try {
            templateActions.updateTemplate(path, newData);
        } catch (error) {
            console.error("Update failed:", error);
        }
    }
};
